/**
 * <s-bike-builder> keeps the build summary in sync with the chosen motor
 * kit setup and battery: battery name, range, top speed, total and the
 * add-to-cart state. The form itself posts natively to the cart.
 */
class BikeBuilder extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#update);
    this.#update();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#update);
  }

  #format(cents) {
    const currency = this.dataset.currency || 'CAD';
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
    }).format(cents / 100);
    return this.dataset.showCode === 'true' ? `${amount} ${currency}` : amount;
  }

  #update = () => {
    const motorSelect = this.querySelector('[data-motor-variant]');
    const motorOption = motorSelect?.selectedOptions[0];
    const battery = this.querySelector('[data-battery-input]:checked');
    if (!motorOption || !battery) return;

    const tile = battery.closest('[data-battery-tile]');
    const text = (selector) => tile?.querySelector(selector)?.textContent.trim() ?? '';

    this.#set('[data-summary-battery]', text('[data-battery-name]'));
    this.#set('[data-summary-range]', text('[data-battery-range]'));
    this.#set('[data-summary-speed]', text('[data-battery-speed]'));
    this.#set('[data-summary-amps]', text('[data-battery-amps]'));
    this.#set('[data-summary-watts]', text('[data-battery-watts]'));

    const total = Number(motorOption.dataset.price) + Number(battery.dataset.price);
    this.#set('[data-summary-total]', this.#format(total));

    const available = motorOption.dataset.available === 'true' && battery.dataset.available === 'true';
    const submit = this.querySelector('[data-builder-submit]');
    if (submit) {
      submit.disabled = !available;
      submit.setAttribute('aria-disabled', String(!available));
      const label = submit.querySelector('[data-builder-submit-label]');
      if (label) label.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
    }
  };

  #set(selector, value) {
    const node = this.querySelector(selector);
    if (node) node.textContent = value;
  }
}

if (!customElements.get('s-bike-builder')) customElements.define('s-bike-builder', BikeBuilder);
